/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SeatAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SeatAction({
  children,
  viewPath = "/DesignSystem/SeatAction/ConfirmationDialog/Content/Content/SeatAction",
  onSubmit,
  isSubmitting
  
}) {
let seatFormSubmitData = fromData.useDataSubmit({ viewPath,
context: 'seat_form',
})
let seatFormIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'seat_form',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="seat_form"
 onClick={seatFormSubmitData}
 disabled={seatFormIsSubmittingData}
 marginLeft={dtSpaceXs}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Start appointment"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}